import { Lms } from "@verity/api-client/types";
import styles from "./LmsIcon.module.css";
import Box from "@mui/material/Box/Box";
import CanvasIcon from "../images/canvas.svg?react";
import MoodleIcon from "../images/moodle.svg?react";
import BlackboardIcon from "../images/blackboard.svg?react";
import Desire2LearnIcon from "../images/D2L.svg?react";
import i18nPackage from "../../i18n/i18n";

function getIconForLms(lms?: Lms): React.ComponentType<React.SVGProps<SVGSVGElement>> | null {
	switch (lms) {
		case "canvas":
			return CanvasIcon;
		case "moodle":
			return MoodleIcon;
		case "BlackboardLearn":
			return BlackboardIcon;
		case "desire2learn":
			return Desire2LearnIcon;
		default:
			return null;
	}
}

type LmsIconProps = {
	lms?: Lms;
	/**@default 24px */
	width?: number;
	/**@default 24px */
	height?: number;
};

export default function LmsIcon({ lms, height = 24, width = 24 }: LmsIconProps) {
	const Icon = getIconForLms(lms);

	if (!Icon) {
		return null;
	}
	return (
		<Box
			className={styles.lmsIcon}
			width={width}
			height={height}
			role="img"
			aria-label={i18nPackage.t("coreComponents.lmsIcon.ariaLabel", { lms })}
		>
			<Icon aria-hidden="true" />
		</Box>
	);
}
